import React from 'react';
import { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import { EyeOutlined } from '@ant-design/icons';
import {
    ResponseErrorCharge,
    CreatedByUser,
    ImportReport,
} from '../../store/ImportRequest';

enum StatusImport {
    completed = 'Completo',
    pending = 'Pendente',
    error = 'Erro',
    processing = 'Processando',
}

enum actionsFormat {
    add = 'Adicionar',
    addOrUpdate = 'Adicionar ou Atualizar',
    update = 'Atualizar',
    overrideAll = 'Substituir Todos',
}

enum TypeImport {
    PRODUCT_GLOBAL = 'Produto Global',
    PRODUCT = 'Produto',
    PLANOGRAM = 'Planograma',
}

export const ImportReportsColumn = (
    openErrorModal: (importId: number) => void,
): ColumnsType => [
    {
        title: 'ID de Importação',
        dataIndex: 'id',
        key: 'id',
        align: 'center',
    },
    {
        title: 'Tipo',
        dataIndex: 'type',
        key: 'type',
        align: 'center',
        ellipsis: true,
        render: (typeImport: keyof typeof TypeImport) => TypeImport[typeImport],
    },
    {
        title: 'Origem',
        dataIndex: 'origin',
        key: 'origin',
        align: 'center',
        ellipsis: true,
        render: (origin: string) => origin,
    },
    {
        title: 'E-mail do Usuário',
        dataIndex: 'createdByUser',
        key: 'createdByUser',
        align: 'center',
        render: (createdByUser: CreatedByUser) => createdByUser?.email,
    },
    {
        title: 'Ação',
        dataIndex: 'action',
        key: 'action',
        align: 'center',
        ellipsis: true,
        render: (action: keyof typeof actionsFormat) => actionsFormat[action],
    },
    {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        align: 'center',
        ellipsis: true,
        render: (status: keyof typeof StatusImport) => StatusImport[status],
    },
    {
        title: 'Mensagem de retorno',
        dataIndex: 'response',
        key: 'response',
        align: 'center',
        render: (response: ResponseErrorCharge) => response?.message || '-',
    },
    {
        title: 'Criado em',
        dataIndex: 'created_at',
        key: 'created_at',
        align: 'center',
        ellipsis: true,
        render: (createdAt: string) =>
            moment(createdAt).format('DD/MM/YYYY [às] HH:mm'),
    },
    {
        title: 'Finalizado em',
        dataIndex: 'finished_at',
        key: 'finished_at',
        align: 'center',
        ellipsis: true,
        render: (finishedAt: string) =>
            finishedAt
                ? moment(finishedAt).format('DD/MM/YYYY [às] HH:mm')
                : '-',
    },
    {
        title: 'Falhas',
        align: 'center',
        fixed: 'right',
        render: (data: ImportReport) => {
            return data.response?.errorNum ? (
                <EyeOutlined
                    style={{
                        color: '#1890ff',
                        cursor: 'pointer',
                        fontSize: 18,
                    }}
                    onClick={() => openErrorModal(data.id)}
                />
            ) : (
                '-'
            );
        },
    },
];
